import { Component, inject, Input } from '@angular/core';
import { MessageService, Question, QuestionGroup } from "@bequeathed/ngx-services";

/**
 * Displays the output of a control in READONLY format
 *
 * @author Dan Bennett (dbennett)
 */
@Component({
    selector: 'display-control',
    templateUrl: './display-control.component.html',
    styleUrls: ['./display-control.component.sass'],
    standalone: true
})
export class DisplayControl {

    @Input() first: boolean | undefined;
    // @ts-expect-error this won't be null
    @Input() question: Question;
    // @ts-expect-error this won't be null
    @Input() group: QuestionGroup;
    // @ts-expect-error this won't be null
    @Input() answer: string | string[];

    messages = inject(MessageService);

    get value(): string {
        if (typeof this.answer === 'string') {
            return this.answer;
        }
        return this.answer.join(', ');
    }

    get optionValue(): string {
        return [...this.question.acceptedValues.values()]
           .filter((o: any) => this.answer.indexOf(o.value) > -1)
           .map((o: any) => this.messages.getText(o.messageCode))
           .join(', ');
    }

    breakLines(value?: string): string {
        if (value) {
            return value.replace('\n', '<br/>')
        }
        return '';
    }
}
